import React, { useState } from "react";
import { Avatar, Button, Box } from "@mui/material";
import { CameraAlt } from "@mui/icons-material";

interface ProfileAvatarProps {
  initialImage?: string;
  onImageChange: (file: File) => void;
  initials: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  initialImage,
  onImageChange,
  initials,
}) => {
  const [previewUrl, setPreviewUrl] = useState(initialImage);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
      onImageChange(file);
    }
  };

  return (
    <Box position="relative">
      <Avatar src={previewUrl} sx={{ height: "150px", width: "150px" }}>
        {initials}
      </Avatar>
      <label style={{ position: "absolute", bottom: 0, right: 0 }}>
        <Button
          component="span"
          size="small"
          variant="contained"
          sx={{ borderRadius: "50%", height: "60px" }}
        >
          <CameraAlt />
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </Button>
      </label>
    </Box>
  );
};

export default ProfileAvatar;
